import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { logout } from "src/store/authSlice";
import { Page } from "src/interfaces/Page";
import { RootState } from "../../store";
import { coursesSelector } from "../coursesSlice";
import { getVideoCourses } from "src/actions/courseActions/learnerCourseActions";

const videoCoursesPaginationAdapter = createEntityAdapter<Page>();

const initialState = {
  pages: videoCoursesPaginationAdapter.getInitialState(),
  total: 0,
  totalItems: 0,
};

export const videoCoursesPaginationSlice = createSlice({
  name: "videoCourses/pagination",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getVideoCourses.fulfilled, (state, { payload }) => {
      return {
        pages: videoCoursesPaginationAdapter.upsertOne(
          { ...state.pages },
          {
            id: parseInt(payload.currentPage),
            items: payload?.data?.map((item: any) => item.courses.id),
          }
        ),
        total: payload.pages,
        totalItems: payload.items,
      };
    });
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const adapterSelectors = videoCoursesPaginationAdapter.getSelectors(
  (s: RootState) => s.videoCoursePagination.pages
);

export const videoCoursesPaginationSelectors = {
  pages: adapterSelectors,
  get: (state: RootState, page: number) =>
    adapterSelectors
      .selectById(state, page)
      ?.items.map((id: number) =>
        coursesSelector.coursesSelector.selectById(state, id)
      ) || [],
  totalPages: (state: RootState) => state.videoCoursePagination.total,

  // total: (state: RootState) => state.continueLearning.totalItems,
};
